const uniNameList = [
  "Burapha University",
  "Chiang Mai University",
  "Chulalongkorn University",
  "HRH Princess Chulabhorn College of Medical Science",
  "Kasetsart University",
  "Khon Kaen University",
  "King Mongkut's Institute of Technology Ladkrabang",
  "King Mongkut's University of Technology North Bangkok",
  "King Mongkut's University of Technology Thonburi",
  "Mae Fah Luang University",
  "Mahasarakham University",
  "Mahidol University",
  "Mahidol University (Ramathibodi Hospital)",
  "Mahidol University (Siriraj Hospital)",
  "Naresuan University",
  "National Institute of Development Administration (NIDA)",
  "Navamindradhiraj University",
  "Phramongkutklao College of Medicine",
  "Praboromarajchanok Institute",
  "Prince of Songkla University",
  "Princess of Naradhiwas University",
  "Ramkhamhaeng University",
  "Silpakorn University",
  "Sirindhorn International Institute of Technology",
  "Srinakharinwirot University",
  "Sukhothai Thammathirat Open University",
  "Suranaree University of Technology",
  "Thaksin University",
  "Thammasat University",
  "Ubon Ratchathani University",
  "University of Phayao",
  "Walailak University"
];

const uniNameOptions = uniNameList.map(m => {
  return { value: m, label: m };
});

export default uniNameOptions;
